/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Delivery_1_TermInputs */

const en_services_delivery_1_term = /** @type {(inputs: Services_Delivery_1_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A focused scope`)
};

const lv_services_delivery_1_term = /** @type {(inputs: Services_Delivery_1_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konkrēts darba apjoms`)
};

/**
* | output |
* | --- |
* | "A focused scope" |
*
* @param {Services_Delivery_1_TermInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_delivery_1_term = /** @type {((inputs?: Services_Delivery_1_TermInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Delivery_1_TermInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_delivery_1_term(inputs)
	return en_services_delivery_1_term(inputs)
});